import { motion } from 'motion/react';
import { useT } from '@/shared/lib/i18n';
import { Button } from '@/shared/ui';

export type HandoffCompleteProps = {
  title: string;
  description: string;
  ctaLabel: string;
  onContinue: () => void;
};

/**
 * Standalone "everyone done" intermission. Briefing-room aesthetic: red
 * eyebrow + display headline + italic lede, animated in, capped by a
 * pop CTA that advances to the next phase.
 */
export const HandoffComplete = ({
  title,
  description,
  ctaLabel,
  onContinue,
}: HandoffCompleteProps) => {
  const t = useT();
  return (
    <main className="mx-auto flex h-full w-full max-w-md flex-col justify-between gap-6 px-6 pt-12 pb-6">
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="pt-8 text-center"
      >
        <div className="eyebrow text-und tracking-[0.22em]">
          {t('play.handoff.all_done_eyebrow')}
        </div>
        <h1 className="mt-2 font-display font-extrabold text-[40px] text-ink leading-[0.95] tracking-[-0.02em] sm:text-[48px]">
          {title}
        </h1>
        <p className="mt-3 text-[14px] text-text-dim italic leading-[1.45]">{description}</p>
      </motion.div>
      <Button variant="orange" onClick={onContinue}>
        {ctaLabel}
      </Button>
    </main>
  );
};
